import { useTranslation, UseTranslationOptions } from 'react-i18next';

export const createUseAppTranslation =
  (namespace: string) =>
  (options: UseTranslationOptions<typeof namespace> = {}) =>
    useTranslation(namespace, options);
